import type {StatusModalType} from 'uikit'
import type {Modals} from './entities'
import type {RootState} from '../index'

// использовать вот так getModal('none' - 'none' это тип модалки)(state)
export const getModal = <T extends Modals['type'], Modal extends Extract<Modals, {type: T}>>(
) => (state: RootState): Modal => {
  return state.modal.modal as Modal;
}

export const getStatusModal = (state: RootState): StatusModalType => state.modal.status

